export const JOURNAL_CATEGORIES = [
  { value: "goals", label: "Goals" },
  { value: "protection", label: "Protection" },
  { value: "inflation", label: "Inflation" },
  { value: "education", label: "Education" },
];

export function categoryLabel(value) {
  return JOURNAL_CATEGORIES.find((c) => c.value === value)?.label || value;
}

export function formatPublishedDate(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return "";
  }
}

/** Resolve a possibly-relative image path to an absolute URL. */
export function resolveImageUrl(pathOrUrl) {
  if (!pathOrUrl) return null;
  if (/^https?:\/\//.test(pathOrUrl)) return pathOrUrl;
  const base = process.env.REACT_APP_BACKEND_URL || "";
  return `${base}${pathOrUrl}`;
}
